<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	export let text = '',
		_class = '';
</script>

<Text element="h2" class={_class}>{text}</Text>
<slot />
